import { handleActions } from "redux-actions";
import { fromJS } from "immutable";
import types from "../types";

const INITIAL_STATE = fromJS({
  isLoadingOptions: false,
  isLoading: false,
  message: "",
  optionsGroup: "",
});

const reducer = handleActions(
  {
    [types.GET_GROUPS_OPTIONS]: (state) => state.set("isLoadingOptions", true),
    [types.GET_GROUPS_OPTIONS_FAIL]: (state) =>
      state.set("isLoadingOptions", false),
    [types.GET_GROUPS_OPTIONS_SUCCESS]: (state, { payload: response }) =>
      state.set("isLoadingOptions", true).set("optionsGroup", response.data),
    [types.REGISTER]: (state) => state.set("isLoading", true),
    [types.REGISTER_FAIL]: (state) => state.set("isLoading", false),
    [types.REGISTER_SUCCESS]: (state, { payload: response }) =>
      state.set("isLoading", false).set("message", response.data.message),
  },
  INITIAL_STATE
);

export default reducer;
